"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import * as _interactions from "./webflow_modules/interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e-137":{"id":"e-137","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-61","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-138"}},"mediaQueries":["main","medium"],"target":{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1710449099843},"e-138":{"id":"e-138","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-62","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-137"}},"mediaQueries":["main","medium"],"target":{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1710449099844}},"actionLists":{"a-61":{"id":"a-61","title":"Hover-Search Modal Row","actionItemGroups":[{"actionItems":[{"id":"a-61-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".search-modal---result-hover-icon","selectorGuids":["9f8d9d19-e577-4d4f-62de-792215333ab1"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1710449104207},"a-62":{"id":"a-62","title":"Hover - Search Modal OffHover","actionItemGroups":[{"actionItems":[{"id":"a-62-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".search-modal---result-hover-icon","selectorGuids":["9f8d9d19-e577-4d4f-62de-792215333ab1"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1710449165554}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SearchModalResultCommunityAndMarket({
  imageSlot = "",
  line1Slot = "",
  line2Slot = "",

  linkProps = {
    href: "#",
  },

  showImage = false,
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Link
      block={"inline"}
      button={false}
      className={"search-modal-result-link-com"}
      data-w-id={"d8be518a-f1fd-313e-be85-ba0c5ffa7965"}
      options={linkProps}
    >
      <Block className={"div-block-97"} tag={"div"}>
        {showImage ? (
          <Block className={"search-modal-image-thumb"} tag={"div"}>
            {imageSlot ?? (
              <Image
                alt={""}
                className={"search-modal---image---slot-class"}
                height={"auto"}
                loading={"lazy"}
                src={
                  "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd33250bf2f46d247e66c9_Artizan-Default%20-%20high.jpeg"
                }
                width={"auto"}
              />
            )}
          </Block>
        ) : null}
        <Block tag={"div"}>
          <Block className={"search-modal-result-line-1"} tag={"div"}>
            {line1Slot ?? (
              <HtmlEmbed
                content={
                  "California &gt; <mark>San</mark> <mark>Francisco</mark> Bay Area"
                }
              />
            )}
          </Block>
          <Block className={"div-block-104"} tag={"div"}>
            {line2Slot ?? (
              <HtmlEmbed
                content={
                  "California &gt; <mark>San</mark> <mark>Francisco</mark> Bay Area"
                }
              />
            )}
          </Block>
        </Block>
        <Block className={"search-modal---result-hover-icon"} tag={"div"}>
          <HtmlEmbed
            className={"html-embed-6"}
            content={
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"/></svg>'
            }
          />
        </Block>
      </Block>
    </Link>
  );
}
